import React, { useState, useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { PAYMENT_TARIFF } from '../../../types';
import { getPricesConfig } from '../../../abtests/getPricesConfig';
import { DEFAULT_DISCOUNT } from '../../../abtests/discountConfig';
import locales from '../../../content.json';
import { getParameterFromURL } from '../../../utils/scripts';
import { isTwoPaymentBlocksPaywallEnabled } from '../../../utils/scripts/twoPaymentBlocksPaywall';
import s from './index.module.scss';

const getFormattedDate = () => {
  const monthNames = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
  const today = new Date();
  const month = monthNames[today.getMonth()];
  const year = today.getFullYear().toString().slice(-2);
  return `${month}${year}`;
};

const PromoCode = ({ tariff, secondScreenWrapper }) => {
	const timerTime = 10; // minutes
	const initialTime = timerTime * 60;
	const [time, setTime] = useState(initialTime);

  const currentTariff = useSelector(state => state.data.tariff || tariff);
  const name = useSelector(state => state.data.name);
  const k9Funnel = useSelector(state => state.data.k9Funnel);
  const specialOfferTariff = useMemo(() => ['v5', 'v7', 'v9', 'v11', 'v13', 'v15', 'v18', 'v20', 'v22', 'v24', 'v26', 'v28', 'v30', 'v32', 'v34', 'v36', 'v38', 'v40', 'v42', 'v44', 'v46'].includes(currentTariff), [currentTariff]);
  const newDesign = useMemo(() => ['v43', 'v44'].includes(currentTariff), [currentTariff]);
  const discountPercent = useMemo(() => getPricesConfig(currentTariff)?.extraOptions?.discountPercent, [currentTariff]);

  const p13MixPaywallDiscountPercent = getParameterFromURL('p13MixPaywallDiscountPercent');

  const p20v1RedLabelDiscountNoSpecial = getParameterFromURL('p20v1RedLabelDiscountNoSpecial') === 'true' && currentTariff === PAYMENT_TARIFF.V41;
  const twoPaymentBlocksPaywall = isTwoPaymentBlocksPaywallEnabled();

  const promocodeTagRef = useRef(null);
  const [tagWidth, setTagWidth] = useState(0);

  const promocodeValue = useMemo(() => {
    const nameValue = name[0] || 'doggy';
    return `${nameValue}_${getFormattedDate()}`;
  }, [name]);

  const minutes = sec => {
		const minutesValue = Math.floor(sec / 60);
		return `${String(minutesValue).padStart(2, '0')}`;
	};

	const seconds = sec => {
		const secondsValue = sec % 60;
		return `${String(secondsValue).padStart(2, '0')}`;
	};

	useEffect(() => {
		const timer = setInterval(() => {
			if (time > 0) {
				setTime(time - 1);
			} else {
				clearInterval(timer);
			}
		}, 1000);

		return () => {
			clearInterval(timer);
		};
	}, [time]);

  useEffect(() => {
    if (!promocodeTagRef.current) return;

    const updateWidth = () => {
      if (promocodeTagRef.current) {
        setTagWidth(promocodeTagRef.current.offsetWidth - 20);
      }
    };

    updateWidth();

    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  const promocodeSaveText = useMemo(() => {
    let saleValue;
    if (newDesign) {
      saleValue = specialOfferTariff ? '70' : '62';
    } else {
      if (p13MixPaywallDiscountPercent) {
        saleValue =  specialOfferTariff ? '72' : '63';
      } else {
        saleValue = specialOfferTariff ? '65' : '53';
      }
    }

    if (currentTariff === 'v45') {
      saleValue = '60';
    } else if (currentTariff === 'v46') {
      saleValue = '70';
    }

    if (discountPercent) {
      saleValue = discountPercent;
    }

    if (p20v1RedLabelDiscountNoSpecial && currentTariff === PAYMENT_TARIFF.V41) {
      saleValue = `${DEFAULT_DISCOUNT}`;
    }

    if (newDesign) {
      return `${saleValue}% off`;
    }

    if (twoPaymentBlocksPaywall) {
      return `${saleValue}${locales[window.userLang].promo_code_save}`;
    }

    return `${saleValue} ${locales[window.userLang].promo_code_save}`;
  }, [
    discountPercent,
    p13MixPaywallDiscountPercent,
    newDesign,
    twoPaymentBlocksPaywall,
    specialOfferTariff,
    currentTariff,
    p20v1RedLabelDiscountNoSpecial,
  ]);

  return (
    <div
      className={`${s.promocodeWrapper} ${
        currentTariff === PAYMENT_TARIFF.V5 ||
        currentTariff === PAYMENT_TARIFF.V7 ||
        currentTariff === PAYMENT_TARIFF.V9 ||
        currentTariff === PAYMENT_TARIFF.V11 ||
        currentTariff === PAYMENT_TARIFF.V13 ||
        currentTariff === PAYMENT_TARIFF.V15 ||
        currentTariff === PAYMENT_TARIFF.V18 ||
        currentTariff === PAYMENT_TARIFF.V20 ||
        currentTariff === PAYMENT_TARIFF.V22 ||
        currentTariff === PAYMENT_TARIFF.V24 ||
        currentTariff === PAYMENT_TARIFF.V26 ||
        currentTariff === PAYMENT_TARIFF.V28 ||
        currentTariff === PAYMENT_TARIFF.V30 ||
        currentTariff === PAYMENT_TARIFF.V32 ||
        currentTariff === PAYMENT_TARIFF.V34
          ? s.tariffV5
          : ''
      } ${secondScreenWrapper ? s.secondScreenWrapperStyle : ''}
      `}
    >
      <div className={`${s.promocodeRound} ${s.promocodeRoundLeft}`} />
      <div className={`${s.promocodeRound} ${s.promocodeRoundRight}`} />
      <div className={s.promocodeDashedLine} />
      <div
        className={`${
          newDesign
            ? s.promocodeTagV2
            : twoPaymentBlocksPaywall
            ? s.promocodeTagPaywall2paymentBlocks
            : `${s.promocodeTag}${k9Funnel ? ` ${s.promocodeTagK9}` : ''}`
        }`}
        ref={promocodeTagRef}
      >
        <p className={s.promocodeTagText}>{promocodeSaveText}</p>
      </div>
      <div className={s.promocodeRows}>
        <div
          className={`${s.promocodeRow} ${s.promocodeRowFirst}`}
          style={{ paddingRight: tagWidth + 8 }}
        >
          <div className={s.promocodeLabel} />
          <p className={s.promocodeTitle} dangerouslySetInnerHTML={{ __html: locales[window.userLang].promo_code_title}} />
        </div>
        <div className={`${s.promocodeRow} ${s.promocodeRowSecond}`}>
          <div className={s.promocodeCodeBlock}>
            <div className={s.promocodeCheck} />
            <p className={s.promocodeText}>{promocodeValue}</p>
          </div>
          <div className={s.promocodeTimerBlock}>
            <div className={s.timerCell}>
              <div className={`${s.timerCellNumber} ${s.timerCellNumberMinutes}`}>{minutes(time)}</div>
            </div>
            <div className={s.timerCellDivider}>:</div>
            <div className={s.timerCell}>
              <div className={`${s.timerCellNumber} ${s.timerCellNumberSeconds}`}>{seconds(time)}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

PromoCode.propTypes = {
  tariff: PropTypes.string,
  secondScreenWrapper: PropTypes.bool,
};

PromoCode.defaultProps = {
  tariff: undefined,
  secondScreenWrapper: false,
};

export default PromoCode;
